module.exports = __webpack_public_path__ + "media/Video 94.f0728520.mp4";